export default __webpack_public_path__ + "static/media/download_project_link.f8fc31a9.svg";